import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "delete"
}
const _hoisted_2 = {
  key: 1,
  class: "clone"
}
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kbutton = _resolveComponent("kbutton")!
  const _component_dialog_actions_bar = _resolveComponent("dialog-actions-bar")!
  const _component_k_dialog = _resolveComponent("k-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_k_dialog, {
      title: _ctx.title,
      onClose: _ctx.toggleDialog,
      class: "alert-dialog"
    }, {
      default: _withCtx(() => [
        (_ctx.setDeleteDialog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("alertComponent.youAreAboutTo")) + " " + _toDisplayString(_ctx.$t("alertComponent.delete")) + " " + _toDisplayString(_ctx.numberOfOperation) + " " + _toDisplayString(_ctx.$t("alertComponent.operations")) + ". ", 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("alertComponent.areYouSureYouWantToProceed")) + " " + _toDisplayString(_ctx.$t("alertComponent.deletion")) + " ?", 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.setCloneDialog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("alertComponent.youAreAboutTo")) + " " + _toDisplayString(_ctx.$t("alertComponent.clone")) + " " + _toDisplayString(_ctx.numberOfOperation) + " " + _toDisplayString(_ctx.$t("alertComponent.operations")) + ". ", 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("alertComponent.areYouSureYouWantToProceed")) + " " + _toDisplayString(_ctx.$t("alertComponent.duplication")) + "?", 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isCancelButtonClicked)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t("alertComponent.areYouSureYouWantToExit")) + " ?", 1))
          : _createCommentVNode("", true),
        _createVNode(_component_dialog_actions_bar, null, {
          default: _withCtx(() => [
            _createVNode(_component_kbutton, {
              class: "cancel",
              onClick: _ctx.toggleDialog
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("alertComponent.cancel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_kbutton, {
              class: "save",
              onClick: _ctx.showGrid
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("alertComponent.ok")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "onClose"])
  ]))
}